import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink } from '../../components';
import css from './JoinPreFooter.css';

const handleShowSpaceHome = () => {
  if (typeof window === 'object' && window.Intercom) {
    window.Intercom('showSpace', 'home');
  }
};

const JoinPreFooter = props => {
  const { showContactButton } = props;
  return (
    <div className={css.root}>
      <div className={css.container}>
        <div className={css.content}>
          <div className={css.textContent}>
            <h2 className={css.title}>
              <FormattedMessage id="JoinPreFooter.title" />
            </h2>
            <p className={css.description}>
              <FormattedMessage id="JoinPreFooter.description" />
            </p>
          </div>
          <div className={css.buttons}>
            <NamedLink name="SignupPage" className={css.button}>
              <FormattedMessage id="JoinPreFooter.buttonText" />
            </NamedLink>
            {showContactButton ? (
              <button type="button" className={css.contactButton} onClick={handleShowSpaceHome}>
                <FormattedMessage id="JoinPreFooter.contactButtonText" />
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinPreFooter;
